// VIN / plaka çözümleyici ürünleri (myaccount LicenseProductId -> sayfa)
export const RESOLVER_PRODUCTS = [
  { licenseProductId: 49, product: "VIN", slug: "vin", menuKey: "MENU_VIN_RESOLVER", name: "Vin Resolver" },
  { licenseProductId: 50, product: "PLATE", slug: "plate", menuKey: "MENU_PLATE_RESOLVER", name: "License Plate Resolver" },
] as const;

export const RESOLVER_LICENSE_PRODUCT_IDS: number[] = RESOLVER_PRODUCTS.map((p) => p.licenseProductId);

export const RESOLVER_API_URL = "https://resolver.huncat.net";
export const RESOLVER_SWAGGER_URL = `${RESOLVER_API_URL}/docs`;
